$(function(){
//marquee line
	let $marqueeLine = $('.js-marquee-text');
	let $marqueeLineSub = $('.js-marquee-text-sub');

	$marqueeLine.marquee({
		direction: 'left',
		duration: 40000,
		gap: 0,
		delayBeforeStart: 0,
		duplicated: true,
		startVisible: true,
		pauseOnHover: true
	});

	$marqueeLineSub.marquee({
		direction: 'right',
		duration: 40000,
		gap: 0,
		delayBeforeStart: 0,
		duplicated: true,
		startVisible: true,
		pauseOnHover: true
	});
});